/**
 * React context for platform engine access in registry-demo.
 */

import { createContext, useContext, type ReactNode } from "react";
import { appSessionApi, type AppSessionApi } from "./sessionApiBridge";

interface PlatformContextValue {
  sessionApi: AppSessionApi;
}

const PlatformContext = createContext<PlatformContextValue | null>(null);

interface PlatformProviderProps {
  children: ReactNode;
}

/**
 * Platform provider component.
 */
export function PlatformProvider({ children }: PlatformProviderProps) {
  const value: PlatformContextValue = {
    sessionApi: appSessionApi,
  };

  return (
    <PlatformContext.Provider value={value}>
      {children}
    </PlatformContext.Provider>
  );
}

/**
 * Hook to access platform context.
 */
export function usePlatformContext(): PlatformContextValue {
  const context = useContext(PlatformContext);
  if (!context) {
    throw new Error(
      "usePlatformContext must be used within PlatformProvider"
    );
  }
  return context;
}

/**
 * Hook to access Session API directly.
 */
export function useSessionApi(): AppSessionApi {
  const { sessionApi } = usePlatformContext();
  return sessionApi;
}

